import { render, staticRenderFns } from "./ResultDetailLastMessage.vue?vue&type=template&id=02074fd2&scoped=true&"
import script from "./ResultDetailLastMessage.vue?vue&type=script&lang=js&"
export * from "./ResultDetailLastMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02074fd2",
  null
  
)

export default component.exports